import React from 'react';
import { Box } from '@mui/material';
import ProfessionalInfoForm from './ProfessionalInfoForm';
import { MarketplaceAccount } from 'types/MarketplaceAccount';
import { StripeAccountStatusType } from 'types/entityTypes/StripeAccountStatusType';

type InfoTabContentProps = {
  stripeAccountStatus: StripeAccountStatusType | undefined;
  marketplaceAccount: MarketplaceAccount | undefined;
};

function InfoTabContent({ stripeAccountStatus, marketplaceAccount }: InfoTabContentProps) {
  return (
    <Box sx={{ width: '100%' }}>
      <ProfessionalInfoForm marketplaceAccount={marketplaceAccount} />
    </Box>
  );
}

export default InfoTabContent; 